/*
 * File: /src/components/Plugins/canva.js
 * Created Date:Friday April 16th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 26th April 2024 1:20:37 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2024 AdBase, Inc.
 */

const defaultOptions = {
  key: '',
  scriptPath: 'https://sdk.canva.com/designbutton/v2/api.js',
};

export default {
  install(app, options) {
    let userOptions = { ...defaultOptions, ...options };

    const load = () => {
      return new Promise((resolve, reject) => {
        if (window.Canva) return resolve();
        ((document, url) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = async () => {
            let canvaApi = await window.Canva.DesignButton.initialize({
              apiKey: userOptions.key,
            });
            app.config.globalProperties.$canva = canvaApi;
            resolve(canvaApi);
          };
          script.onerror = reject;
          document.body.appendChild(script);
        })(document, userOptions.scriptPath);
      });
    };

    load();
  },
};
